import React from "react";
import { Box, FormControl, FormControlLabel, Paper, Radio, RadioGroup, Typography } from "@mui/material";

const NAVY = "#1E3A5F";

/**
 * Shown on the last step of an edit when somebody OTHER than the creator is editing: who pays for this edit?
 * The server refunds whoever really paid for the policy and charges the one chosen here.
 *
 * @param {string}   creatorName  the creator's name ("" when unknown)
 * @param {string}   editorName   the logged-in editor's name
 * @param {string}   value        "creator" | "editor"
 * @param {Function} onChange     called with "creator" | "editor"
 */
const EditPayerChoice = ({ creatorName = "", editorName = "", value = "creator", onChange }) => {
  const creator = creatorName || "the person who created it";
  const editor = editorName ? `You (${editorName})` : "You";
  return (
    // the Preview's own column width (980px, centred), so the two line up on the last step
    <Paper elevation={0} sx={{ mt: 1, mx: "auto", maxWidth: 980, p: { xs: 1.5, sm: 2 }, border: "1px solid #EAECF0", borderRadius: "12px" }}>
      <Typography sx={{ fontWeight: 700, fontSize: 16, color: NAVY }}>Who pays for this edit?</Typography>
      <Typography sx={{ fontSize: 12.5, color: "#667085", mb: 0.5 }}>
        This policy was created by {creator}. What it already paid is given back to them; the new amount is charged to
        the wallet you choose.
      </Typography>
      <FormControl>
        <RadioGroup
          aria-label="Who pays for this edit"
          value={value}
          onChange={(event) => onChange && onChange(event.target.value)}
        >
          <FormControlLabel value="creator" control={<Radio size="small" />} label={`${creator} (the creator)`} />
          <FormControlLabel value="editor" control={<Radio size="small" />} label={`${editor} (the editor)`} />
        </RadioGroup>
      </FormControl>
      <Box sx={{ fontSize: 12, color: "#667085" }}>
        Their Company Wallet and, for a user login, their Policy Wallet are the ones used.
      </Box>
    </Paper>
  );
};

export default EditPayerChoice;
